export default __webpack_public_path__ + "static/media/Siblings.4a7ea159.jpg";